export { default } from './ServicesBannersSlider';
